export type Gender = 'm' | 'k'; // consider to use English equivalents (BE changes needed)

export const GENDER: { [key in Gender]: Gender } = {
  m: 'm',
  k: 'k',
};
